import { application } from "./application";

import UploadPreviewController from "./upload_preview_controller";
application.register("upload-preview", UploadPreviewController);

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);

import PrintController from "./print_controller";
application.register("print", PrintController);

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

import ReactController from "./react_controller";
application.register("react", ReactController);

// import CookieConsentController from "./cookie_consent_controller";
// application.register("cookie-consent", CookieConsentController);

import ToastController from "./toast_controller";
application.register("toast", ToastController);

import FormController from "./form_controller";
application.register("form", FormController);

import DialogController from "./dialog_controller";
application.register("dialog", DialogController);

import DialogButtonController from "./dialog_button_controller";
application.register("dialog-button", DialogButtonController);

import FeedbackController from "./feedback_controller";
application.register("feedback", FeedbackController);
